"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultTemplatesOnPlatform = exports.getAllTemplatesOnPlatform = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const agentForTeams_1 = require("./agentForTeams");
const bot_1 = require("./bot");
const customEngineAgent_1 = require("./customEngineAgent");
const graphConnector_1 = require("./graphConnector");
const me_1 = require("./me");
const special_1 = require("./special");
const tab_1 = require("./tab");
const tdp_1 = require("./tdp");
const vs_1 = require("./vs");
const wxp_1 = require("./wxp");
const allTemplates = [
    ...tab_1.tabTemplates,
    ...bot_1.basicBotTemplates,
    ...me_1.messagingExtensionTemplates,
    ...customEngineAgent_1.customEngineAgentTemplates,
    ...agentForTeams_1.agentForTeamsTemplates,
    ...tdp_1.tdpTemplates,
    ...special_1.specialTemplates,
    ...vs_1.vsOnlyTemplates,
    ...wxp_1.wxpTemplates,
    ...graphConnector_1.graphConnectorTemplates,
];
const defaultGeneratorTemplates = [
    ...tab_1.tabTemplates,
    ...bot_1.basicBotTemplates,
    ...me_1.messagingExtensionTemplates,
    ...customEngineAgent_1.customEngineAgentTemplates,
    ...agentForTeams_1.agentForTeamsTemplates,
    ...tdp_1.tdpTemplates,
    ...vs_1.vsOnlyTemplates,
    ...graphConnector_1.graphConnectorTemplates,
];
// used by programming language question options filter
function getAllTemplatesOnPlatform(platform) {
    switch (platform) {
        case teamsfx_api_1.Platform.VSCode:
            return allTemplates.filter((t) => t.language !== "csharp");
        case teamsfx_api_1.Platform.VS:
            return allTemplates.filter((t) => t.language === "csharp");
        case teamsfx_api_1.Platform.CLI:
            return allTemplates;
        default:
            return [];
    }
}
exports.getAllTemplatesOnPlatform = getAllTemplatesOnPlatform;
// used by default generator
function getDefaultTemplatesOnPlatform(platform) {
    switch (platform) {
        case teamsfx_api_1.Platform.VSCode:
            return defaultGeneratorTemplates.filter((t) => t.language !== "csharp");
        case teamsfx_api_1.Platform.VS:
            return defaultGeneratorTemplates.filter((t) => t.language === "csharp");
        case teamsfx_api_1.Platform.CLI:
            return defaultGeneratorTemplates;
        default:
            return [];
    }
}
exports.getDefaultTemplatesOnPlatform = getDefaultTemplatesOnPlatform;
//# sourceMappingURL=index.js.map